import React from "react";
import { assetPathFor, isDouble } from "../engine/dominoMap";

export interface TileProps {
  card: number;
  size: number;
  orientation?: "horizontal" | "vertical" | "back";
  highlighted?: boolean;
  dimmed?: boolean;
  onClick?: () => void;
  title?: string;
}

const TILE_BG = "#fdfaf2";
const TILE_BORDER = "#1f1f1f";

export const Tile: React.FC<TileProps> = ({
  card,
  size,
  orientation,
  highlighted,
  dimmed,
  onClick,
  title,
}) => {
  const isBack = orientation === "back";
  const dbl = !isBack && isDouble(card);
  const orient = orientation ?? (dbl ? "vertical" : "horizontal");
  const long = size;
  const short = size / 2;
  const w = orient === "horizontal" ? long : short;
  const h = orient === "horizontal" ? short : long;

  const wrapperStyle: React.CSSProperties = {
    width: w,
    height: h,
    background: TILE_BG,
    border: `${Math.max(1, Math.round(size * 0.025))}px solid ${TILE_BORDER}`,
    borderRadius: Math.max(2, size * 0.06),
    boxShadow: highlighted
      ? "0 0 0 3px #FED100, 0 4px 10px rgba(0,0,0,0.35)"
      : "0 2px 4px rgba(0,0,0,0.25)",
    cursor: onClick ? "pointer" : "default",
    overflow: "hidden",
    opacity: dimmed ? 0.45 : 1,
    transition: "box-shadow 120ms, opacity 120ms",
    flex: "0 0 auto",
    position: "relative",
    boxSizing: "border-box",
  };

  if (isBack) {
    return (
      <div style={wrapperStyle} title={title} onClick={onClick}>
        <div
          style={{
            width: "100%",
            height: "100%",
            background:
              "repeating-linear-gradient(45deg, #1f1f1f 0 6px, #2a2a2a 6px 12px)",
          }}
        />
      </div>
    );
  }

  // Asset PNGs are portrait (105x200). Vertical orientation = display natively;
  // horizontal orientation = rotate 90° so the long axis lies along the chain.
  if (orient === "vertical") {
    return (
      <div style={wrapperStyle} title={title} onClick={onClick}>
        <img
          src={assetPathFor(card)}
          alt=""
          draggable={false}
          style={{ width: "100%", height: "100%", display: "block" }}
        />
      </div>
    );
  }

  return (
    <div style={wrapperStyle} title={title} onClick={onClick}>
      <img
        src={assetPathFor(card)}
        alt=""
        draggable={false}
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          width: short,
          height: long,
          transform: "translate(-50%, -50%) rotate(90deg)",
          display: "block",
        }}
      />
    </div>
  );
};
